import 'Styles/settings.scss';

import React from 'react';
import { connect } from 'react-redux';

import AvatarEditor from 'react-avatar-editor'
import isEqual from 'lodash/isEqual';

import userprofileResultSelector from 'Selectors/userprofileResultSelector';

import parse from 'date-fns/parse';
import isDate from 'date-fns/is_date';
import isValid from 'date-fns/is_valid';
import format from 'date-fns/format';

import decode from 'Utils/entities';

import UserIcon from 'Components/common/UserIconComponent';
import SvgIcon from 'Components/svg/SvgIcon';
import CheckboxComponent from 'Components/common/CheckboxComponent';

import { fetchUserProfile, uploadAvatar, saveUserCP } from 'Actions/UserprofileActions';
import { receiveGlobalMeta } from 'Actions/MetaActions';
import { displayNotification, showConfirmModal } from 'Actions/UiActions';

import { trackGAEvent } from 'Actions/adsActions';

//canvas.toBlob polyfill for safari
import 'Utils/polyfills/canvas-to-blob';

class UserCPComponent extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			maxH: ( window.innerHeight || document.documentElement.clientHeight ),
			maxW: ( window.innerWidth || document.documentElement.clientWidth ),
			avatar: {
				editAvatar: false,
				url: null,
				scale: 1,
				rotate: 0,
				preview: null
			},
			password: {
				length: null,
				lowerCase: null,
				upperCase: null,
				numbers: null,
				symbols: null
			}
		};

		this.isRestoring = false;
		this.isSaving = {};
		this.avatar = {
			editor: null,
			scale: 1,
			rotate: 0
		};
		this.fields = {};
		this.fieldTexts = {};
	}

	componentWillMount() {
		let userReq = {
			id: 0,
			cp: true,
			page: 1
		};
		this.props.dispatch( fetchUserProfile( userReq, new Date().getTime() ) );
	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			!isEqual( this.props.ustate, nextProps.ustate ) ||
			!isEqual( this.state, nextState )
		);
	}

	componentDidMount() {
		this.props.dispatch( receiveGlobalMeta( null, 'User Control Panel', this.props.siteTitle ) );
	}

	/* ************** */
	hideElement = ( el ) => {
		let list = Array.isArray( el ) ? el : [ el ];
		list.forEach( ( element ) => {
			if( element ) {
				element.classList.add( 'hidden' );
			}
		} );
	};
	showElement = ( el ) => {
		let list = Array.isArray( el ) ? el : [ el ];
		list.forEach( ( element ) => {
			if( element ) {
				element.classList.remove( 'hidden' );
			}
		} );
	};
	/* ************** */

	focusField( field ) {
		if( this.fields[ field ] ) {
			this.fields[ `${ field }` ].focus();
		}
	}

	editField( field ) {
		if( this.fields[ field ] ) {
			let fields = null,
				fieldTexts = null,
				editField = this.fields[ `${ field }_edit` ],
				saveField = this.fields[ `${ field }_save` ],
				restoreField = this.fields[ `${ field }_restore` ];

			switch( field ) {
				case 'password':
					// password fields
					fields = [
						restoreField,
						this.fields[ `${ field }` ],
						this.fields[ `${ field }_verify` ]
					];
					fieldTexts = [
						this.fieldTexts[ `${ field }` ],
						this.fieldTexts[ `${ field }_verify` ],
						this.fieldTexts[ `${ field }_rules` ]
					];
					if( this.fields[ `${ field }_current` ] ) {
						fieldTexts.push( this.fields[ `${ field }_current` ] );
					}

					this.hideElement( [ editField ]  );
					this.showElement( fields );
					this.showElement( fieldTexts );

					fields[ 0 ].focus();
					break;

				case 'birthday':
					// Show/hide action icons
					this.hideElement( [ editField ]  );
					this.showElement( [ saveField, restoreField ] );

					this.fields[ `${ field }` ].focus();
					break;

				case 'dst':
				case 'timezone':
				case 'showbirthday':
					fieldTexts = this.fields[ `${ field }` ];
					fields = this.fields[ `${ field }_select` ];

					this.hideElement( [ editField, fieldTexts ] );
					this.showElement( [ saveField, restoreField, fields ] );
					break;

				default:
					// Show/hide action icons
					this.hideElement( [ editField ]  );
					this.showElement( [ saveField, restoreField ] );
					break;
			}
		}
	}

	saveCheckedField( event ) {
		this.saveField( event.target.name, false );
	}

	saveField( field, force = false ) {
		setTimeout( () => {
			if( this.isSaving[ field ] ) {
				return false;
			}
			if( this.isRestoring ) {
				this.isRestoring = false;
			} else {
				this.isSaving[ field ] = true;

				let valueToSave = null,
					editField = this.fields[ `${ field }` ],
					editField2 = null;

				switch( field ) {
					case 'email':
						if( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( editField.innerHTML ) ) {
							editField.classList.remove( 'isok', 'notok' );

							if( editField && ( force || editField.dataset.original !== editField.innerHTML ) ) {
								valueToSave = [ [ field, editField.innerHTML ] ];
							}

						} else {
							editField.classList.add( 'notok' );
							editField.classList.remove( 'isok' );
							displayNotification( 'warning', 'You entered an invalid email address', { timeout: 2000 } );
						}
						break;

					case 'password':
						editField2 = this.fields[ `${ field }_current` ];

						if( this.verifyPass() && force ) {
							if( editField2 ) {
								valueToSave = [ [ field, editField.value ], [ 'password_current', editField2.value ] ];
							} else {
								valueToSave = [ [ field, editField.value ] ];
							}
						}
						break;

					case 'birthday':
						if( this.verifyBirthday() ) {
							if( this.fields.birthday.value !== this.fields.birthday.dataset.original ) {
								valueToSave = [ [ field, this.fields.birthday.value ] ];
							}
						} else {
							displayNotification( 'warning', 'You entered an invalid date', { timeout: 2000 } );
						}
						break;

					case 'dst':
					case 'timezone':
					case 'showbirthday':
						editField = this.fields[ `${ field }_select` ];
						let selectedValue = editField.value,
							theField = this.fields[ `${ field }` ];

						this.hideElement( editField );
						this.showElement( theField );

						valueToSave = [ [ field, selectedValue ] ];
						break;

					default:
						// Check box items
						if( editField.state && typeof editField.state.itemChecked !== 'undefined' ) {
							valueToSave = [ [ field, editField.state.itemChecked ] ];
						} else {
							if( editField && ( force || editField.dataset.original !== editField.innerHTML ) ) {
								valueToSave = [ [ field, editField.innerHTML ] ];
							}
						}
				}

				this.restoreIcons( field );

				if( valueToSave && valueToSave.length && field ) {
					valueToSave = [ [ 'field', field ], ...valueToSave ];

					let response = this.props.dispatch( saveUserCP( valueToSave ) );

					response.then( r => {
						this.isSaving[ field ] = false;
						if( r().result ) {
							if( field === 'password' ) {
								this.cancelField( field );
							}
						} else {
							this.cancelField( field );
							this.editField( field );
						}
					} ).catch( ( error ) => {
						topifyConsole.error( error );
						this.isSaving[ field ] = false;
						this.cancelField( field );
					} );
				} else {
					this.isSaving[ field ] = false;
				}
			}
		}, 50 );
	}

	cancelField( field ) {
		this.isRestoring = true;

		let theField,
			theField2,
			theField3;

		switch( field ) {
			case 'email':
				theField = this.fields[ `${ field }` ];
				theField.innerHTML = theField.dataset.original;
				break;

			case 'password':
				theField = this.fields[ `${ field }` ];
				theField2 = this.fields[ `${ field }_verify` ];
				theField3 = this.fields[ `${ field }_current` ];
				let fields = theField3 ? [ theField, theField2, theField3 ] : [ theField, theField2 ];
				let fieldTexts = [
						this.fieldTexts[ `${ field }` ],
						this.fieldTexts[ `${ field }_verify` ],
						this.fieldTexts[ `${ field }_rules`]
					];

				if( this.fieldTexts[ `${ field }_current` ] ) {
					fieldTexts.push( this.fieldTexts[ `${ field }_current` ] );
				}

				this.hideElement( fieldTexts );
				this.hideElement( fields );

				theField.value = '';
				theField.blur();
				theField2.value = '';
				theField2.blur();
				if( theField3 ) {
					theField3.value = '';
					theField3.blur();
				}
				this.verifyPassRules();
				break;

			case 'birthday':
				this.fields[ `${ field }` ].classList.remove( 'isok', 'notok' );
				this.fields[ `${ field }` ].value = this.fields[ `${ field }` ].dataset.original;
				break;

			case 'dst':
			case 'timezone':
			case 'showbirthday':
				theField = this.fields[ `${ field }` ];
				theField2 = this.fields[ `${ field }_select` ];

				this.hideElement( theField2 );
				this.showElement( theField );

				theField2.value = theField2.dataset.original;
				break;

			default:
				document.execCommand( 'undo' );
				this.fields[ `${ field }` ].blur();
		}

		this.restoreIcons( field );
		this.isRestoring = false;
	}

	restoreIcons( field ) {
		let showFields = [ this.fields[ `${ field }_edit` ] ],
			hideFields = [
				this.fields[ `${ field }_save` ],
				this.fields[ `${ field }_restore` ]
			];
		this.showElement( showFields );
		this.hideElement( hideFields );
	}

	/* ************** */

	/** Options **/
	showUserOptions() {
		let loaded = this.props.ustate.usercp && this.props.ustate.usercp.profile;

		if( !loaded ) {
			return null;
		}

		let options = this.props.ustate.usercp.options,
			dstOptions = [],
			timezoneOptions = [];

		let option,
			aux = null,
			op = null;

		for( option in options.dst.dst_options ) {
			if( options.dst.dst_options.hasOwnProperty( option ) ) {
				op = <option key={ option } value={ option }>{ decode( options.dst.dst_options[ option ] ) }</option>;
				dstOptions.push( op );
			}
		}
		for( option in options.dst.timezone_options ) {
			if( options.dst.timezone_options.hasOwnProperty( option ) ) {
				aux = options.dst.timezone_options[ option ];
				op = <option key={ option } value={ aux[ 0 ] }>{ decode( aux[ 1 ] ) }</option>;
				timezoneOptions.push( op );
			}
		}

		let optionField,
			settingoption = null,
			settingOptions = [],
			settingsMessaging = [],
			settingsDateTime = [];

		// Options checkboxes for 'Receive Email'
		for( optionField in options.email ) {
			if(
				options.email[ optionField ] &&
				options.email[ optionField ].text !== null &&
				options.email[ optionField ].value !== null
			) {
				let this_optionField = optionField;
				settingoption = <dd key={ this_optionField }>
					<CheckboxComponent
						name={ this_optionField }
						id={ this_optionField }
						postLabel={ options.email[ this_optionField ].text }
						value="1"
						className="inLine"
						checked={ parseInt( options.email[ this_optionField ].value ) === 1 }
						multiple={ true }
						ref={ ( op ) => this.fields[ this_optionField ] = op }
						onChange={ ( e ) => this.saveCheckedField( e ) }
					/>
				</dd>;
				settingOptions.push( settingoption );
			}
		}

		if( settingOptions.length ) {
			settingoption = <dl key="recemail">
				<dt>Receive Email</dt>
				{ settingOptions }
			</dl>;
			settingsMessaging.push( settingoption );
			settingOptions = [];
		}

		// Options checkboxes for 'Private Messaging'
		for( optionField in options.pm ) {
			if(
				options.pm[ optionField ] &&
				options.pm[ optionField ].text !== null &&
				options.pm[ optionField ].value !== null
			) {
				let this_optionField = optionField;
				settingoption = <dd key={ this_optionField }>
					<CheckboxComponent
						name={ this_optionField }
						id={ this_optionField }
						postLabel={ options.pm[ this_optionField ].text }
						value="1"
						className="inLine"
						checked={ parseInt( options.pm[ this_optionField ].value ) === 1 }
						multiple={ true }
						ref={ ( op ) => this.fields[ this_optionField ] = op }
						onChange={ ( e ) => this.saveCheckedField( e ) }
					/>
				</dd>;
				settingOptions.push( settingoption );
			}
		}

		if( settingOptions.length ) {
			settingoption = <dl key="messaging">
				<dt>Private Messaging</dt>
				{ settingOptions }
			</dl>;
			settingsMessaging.push( settingoption );
		}

		// Date & Time
		if( options.dst !== null ) {
			let timeZoneSelected = options.dst.timezone ? options.dst.timezone_options.filter( (t) => t[0].toString() === options.dst.timezone.toString() )[0] : [];

			settingsDateTime = [
				<dl key="timezone">
					<dt>Time Zone</dt>
					<dd className="options">
						<div className="icon action-button edit" ref={ (f) => this.fields[ 'timezone_edit' ] = f } onClick={ () => this.editField( 'timezone' ) } ><SvgIcon icon="edit" size="20px"/></div>
						<div className="icon action-button restore hidden" ref={ (f) => this.fields[ 'timezone_restore' ] = f } onClick={ () => this.cancelField( 'timezone' ) } ><SvgIcon icon="restore" size="20px"/></div>
						<div className="icon action-button save hidden" ref={ (f) => this.fields[ 'timezone_save' ] = f } onClick={ () => this.saveField( 'timezone', true ) } ><SvgIcon icon="check" size="20px"/></div>
					</dd>
					<dd className="styled-field">
						<span
							className="selectedItem"
							onClick={ () => this.editField( 'timezone' ) }
							ref={ (f) => this.fields[ 'timezone' ] = f }
						>{ decode( ( timeZoneSelected.length ? timeZoneSelected[1] : 'choose one' ) ) }</span>
						<select
							className="hidden"
							name="timezone"
							ref={ (f) => this.fields[ 'timezone_select' ] = f }
							defaultValue={ options.dst.timezone }
							data-original={ options.dst.timezone }
						>{ timezoneOptions }</select>
					</dd>
				</dl>
			];

			if( dstOptions.length ) {
				let dstSelect = <dl key="dst">
					<dt>DST Correction Option</dt>
					<dd className="options">
						<div className="icon action-button edit" ref={ ( f ) => this.fields[ 'dst_edit' ] = f }
							 onClick={ () => this.editField( 'dst' ) }><SvgIcon icon="edit" size="20px"/></div>
						<div className="icon action-button restore hidden"
							 ref={ ( f ) => this.fields[ 'dst_restore' ] = f }
							 onClick={ () => this.cancelField( 'dst' ) }><SvgIcon icon="restore" size="20px"/></div>
						<div className="icon action-button save hidden" ref={ ( f ) => this.fields[ 'dst_save' ] = f }
							 onClick={ () => this.saveField( 'dst', true ) }><SvgIcon icon="check" size="20px"/></div>
					</dd>
					<dd className="styled-field">
						<span
							className="selectedItem"
							onClick={ () => this.editField( 'dst' ) }
							ref={ ( f ) => this.fields[ 'dst' ] = f }
						>{ decode( options.dst.dst_options[ options.dst.dst ] ) }</span>
						<select
							className="hidden"
							name="dst"
							ref={ ( f ) => this.fields[ 'dst_select' ] = f }
							defaultValue={ options.dst.dst }
							data-original={ options.dst.dst }
						>{ dstOptions }</select>
					</dd>
				</dl>;
				settingsDateTime.push( dstSelect );
			}
		}

		return [
			<li key="messaging" className="settings-element">
				<div className="title">Messaging & Notifications Options:</div>
				{ settingsMessaging }
			</li>,
			<li key="datetime" className="settings-element">
				<div className="title">Date & Time Options:</div>
				{ settingsDateTime }
			</li>,
		];
	}

	/** Email & Password Methods **/
	verifyPass() {
		// Current password?
		let currentPassOk = true,
			currentPass = this.fields.password_current;

		if(
			this.props.ustate.usercp.profile.needscurrentpass &&
			!( currentPass && currentPass.value )
		) {
			this.fields.password_current.classList.add( 'notok' );
			this.fields.password_current.classList.remove( 'isok' );
			this.hideElement( this.fields[ `password_save` ] );
			currentPassOk = false;
		} else if( currentPass ) {
			this.fields.password_current.classList.remove( 'isok', 'notok' );
		}

		// New password
		if (
			this.verifyPassRules() &&
			currentPassOk &&
			this.fields.password &&
			this.fields.password_verify &&
			this.fields.password.value.length &&
			this.fields.password.value === this.fields.password_verify.value
		) {
			this.fields.password_verify.classList.add( 'isok' );
			this.fields.password_verify.classList.remove( 'notok' );
			this.showElement( this.fields[ `password_save` ] );
			return true;
		} else {
			this.fields.password_verify.classList.add( 'notok' );
			this.fields.password_verify.classList.remove( 'isok' );
			this.hideElement( this.fields[ `password_save` ] );
			return false;
		}
	}

	verifyPassRules() {
		let passOk = true;

		if( this.props.ustate.usercp.profile && this.props.ustate.usercp.profile.passwordRules ) {
			let rules = this.props.ustate.usercp.profile.passwordRules,
				statePassword = Object.assign( {}, this.state.password );

			if( rules.passwordLength ) {
				statePassword.length = this.fields.password.value.length >= parseInt( rules.passwordLength );
				passOk = passOk & statePassword.length;
			}
			if( rules.containsLowerCase ) {
				statePassword.lowerCase = /[a-z]+/.test( this.fields.password.value );
				passOk = passOk & statePassword.lowerCase;
			}
			if( rules.containsUpperCase ) {
				statePassword.upperCase = /[A-Z]+/.test( this.fields.password.value );
				passOk = passOk & statePassword.upperCase;
			}
			if( rules.containsNumbers ) {
				statePassword.numbers = /[0-9]+/.test( this.fields.password.value );
				passOk = passOk & statePassword.numbers;
			}
			if( rules.containsSymbols ) {
				statePassword.symbols = /\W+/.test( this.fields.password.value );
				passOk = passOk & statePassword.symbols;
			}

			this.setState( { password: statePassword } );
		}

		return passOk;
	}

	showEmailPass() {
		let loaded = this.props.ustate.usercp && this.props.ustate.usercp.profile,
			canChangeEmail = loaded && this.props.ustate.usercp.profile.canmodifyemail,
			needsCurrentPass = loaded && this.props.ustate.usercp.profile.needscurrentpass;

		if( !loaded ) {
			return null;
		}

		let passField = null,
			passwordForm = [
				<dd key="password_icon" className="options" >
					<div className="icon action-button edit" ref={ (f) => this.fields[ 'password_edit' ] = f } onClick={ () => this.editField( 'password' ) } ><SvgIcon icon="edit" size="20px"/></div>
					<div className="icon action-button restore hidden" ref={ (f) => this.fields[ 'password_restore' ] = f } onClick={ () => this.cancelField( 'password' ) } ><SvgIcon icon="restore" size="20px"/></div>
					<div className="icon action-button save hidden" ref={ (f) => this.fields[ 'password_save' ] = f } onClick={ () => this.saveField( 'password', true ) } ><SvgIcon icon="check" size="20px"/></div>
				</dd>
			];
		// do we need the user to include current password?
		if( needsCurrentPass ) {
			passField = <dd key="currentpassword">
				<span className="label hidden" ref={ ( f ) => this.fieldTexts[ 'password_current' ] = f }>Your current password:</span>
				<input className="hidden" type="password" placeholder="current password" onInput={ () => this.verifyPass() }
					   ref={ ( f ) => this.fields[ 'password_current' ] = f }/>
			</dd>;
			passwordForm.push( passField );
		}

		passField = [
			<dd key="newpassword">
				<span className="label hidden" ref={ (f) => this.fieldTexts[ 'password' ] = f }>Your new password:</span>
				<input className="hidden" type="password" placeholder="password" ref={ (f) => this.fields[ 'password' ] = f } onInput={ () => this.verifyPassRules() } />
			</dd>,
			<dd key="verifypassword">
				<span className="label hidden" ref={ (f) => this.fieldTexts[ 'password_verify' ] = f }>Verify new password:</span>
				<input className="hidden" type="password" placeholder="verify password" ref={ (f) => this.fields[ 'password_verify' ] = f } onInput={ () => this.verifyPass() } />
			</dd>
		];

		if( this.props.ustate.usercp.profile.passwordRules ) {
			let passwordRules = this.props.ustate.usercp.profile.passwordRules,
				state = this.state,
				ruleOk = false,
				rule,
				rules = [];

			Object.keys( this.props.ustate.usercp.profile.passwordRules ).forEach( ( item ) => {
				if( passwordRules[ item ] ) {
					switch( item ) {
						case 'passwordLength':
							ruleOk = state.password.length ? <SvgIcon icon="check" size="20px"/> :
								<SvgIcon icon="cancel" size="20px"/>;
							rule =
								<li key="passrules_length" className={ state.password.length ? 'isok' : 'notok' }>{ ruleOk } Minimum length is { passwordRules[ item ] }</li>;
							rules.push( rule );
							break;

						case 'containsLowerCase':
							ruleOk = state.password.lowerCase ? <SvgIcon icon="check" size="20px"/> :
								<SvgIcon icon="cancel" size="20px"/>;
							rule = <li key="passrules_lowercase" className={ state.password.lowerCase ? 'isok' : 'notok' }>{ ruleOk } Must
								contain lower-case characters</li>;
							rules.push( rule );
							break;

						case 'containsUpperCase':
							ruleOk = state.password.upperCase ? <SvgIcon icon="check" size="20px"/> :
								<SvgIcon icon="cancel" size="20px"/>;
							rule = <li key="passrules_uppercase" className={ state.password.upperCase ? 'isok' : 'notok' }>{ ruleOk } Must
								contain upper-case characters</li>;
							rules.push( rule );
							break;

						case 'containsNumbers':
							ruleOk = state.password.numbers ? <SvgIcon icon="check" size="20px"/> :
								<SvgIcon icon="cancel" size="20px"/>;
							rule = <li key="passrules_numbers" className={ state.password.numbers ? 'isok' : 'notok' }>{ ruleOk } Must
								contain numbers</li>;
							rules.push( rule );
							break;

						case 'containsSymbols':
							ruleOk = state.password.symbols ? <SvgIcon icon="check" size="20px"/> :
								<SvgIcon icon="cancel" size="20px"/>;
							rule = <li key="passrules_symbols" className={ state.password.symbols ? 'isok' : 'notok' }>{ ruleOk } Must
								contain symbols</li>;
							rules.push( rule );
							break;
					}
				}
			} );

			let rulesList = <dd key="passrules" className="password-rules hidden" ref={ (f) => this.fieldTexts[ 'password_rules' ] = f } ><ul>{ rules }</ul></dd>;
			passField.unshift( rulesList );
		}

		passwordForm = [ ...passwordForm, ...passField ];

		let settings = (
			<dl key="settings">
				<dt>e-mail</dt>
				<dd className="options">
					<span className="note alert">{ canChangeEmail ? '' : 'you are not allowed to change your email' }</span>
					<div className={`icon action-button edit${ canChangeEmail ? '' : ' hidden' }`} ref={ (f) => this.fields[ 'email_edit' ] = f } onClick={ () => this.focusField( 'email' ) } ><SvgIcon icon="edit" size="20px"/></div>
					<div className="icon action-button restore hidden" ref={ (f) => this.fields[ 'email_restore' ] = f } onClick={ () => this.cancelField( 'email' ) } ><SvgIcon icon="restore" size="20px"/></div>
					<div className="icon action-button save hidden" ref={ (f) => this.fields[ 'email_save' ] = f } onClick={ () => this.saveField( 'email', true ) } ><SvgIcon icon="check" size="20px"/></div>
				</dd>
				<dd>
					<span
						contentEditable={ canChangeEmail }
						onBlur={ () => this.saveField( 'email' ) }
						onFocus={ () => this.editField( 'email' ) }
						onInput={ () => this.editField( 'email' ) }
						ref={ (f) => this.fields[ 'email' ] = f }
						data-original={ this.props.ustate.usercp.profile.email }
					>{ this.props.ustate.usercp.profile.email }</span>
				</dd>
				<dt>Password</dt>
					{ passwordForm }
			</dl>
		);

		return (
			<li className="settings-element">
				<div className="title">Email & Password:</div>
				{ settings }
			</li>
		);
	}

	/** User Profile **/
	verifyBirthday() {
		let bd = parse( this.fields.birthday.value ),
			isValidBD = bd && isDate( bd ) && isValid( bd );

		this.fields.birthday.classList.toggle( 'isok', isValidBD );
		this.fields.birthday.classList.toggle( 'notok', !isValidBD );

		return isValidBD;
	}

	showUserProfile() {
		let loaded = this.props.ustate.usercp && this.props.ustate.usercp.profile;

		if( !loaded ) {
			return null;
		}

		let birthDaySettings = this.props.ustate.usercp.profile.birthday,
			bday = parse( birthDaySettings.birthday ),
			birthdayFormated = bday && isDate( bday ) && isValid( bday ) ? format( bday, 'YYYY-MM-DD' ) : '',
			showBirthDay = birthDaySettings.showbirthday,
			showbirthdayOptions = [],
			option,
			op = null;

		for( option in birthDaySettings.showbirthday_options ) {
			if( birthDaySettings.showbirthday_options.hasOwnProperty( option ) ) {
				op = <option key={ option } value={ option }>{ birthDaySettings.showbirthday_options[ option ] }</option>;
				showbirthdayOptions.push( op );
			}
		}

		let bdPrivacy = showbirthdayOptions.length > 0 ?
			[
				<dt key="privacy_t">Privacy</dt>,
				<dd key="privacy_o" className="options">
					<div className="icon action-button edit" ref={ (f) => this.fields[ 'showbirthday_edit' ] = f } onClick={ () => this.editField( 'showbirthday' ) } ><SvgIcon icon="edit" size="20px"/></div>
					<div className="icon action-button restore hidden" ref={ (f) => this.fields[ 'showbirthday_restore' ] = f } onClick={ () => this.cancelField( 'showbirthday' ) } ><SvgIcon icon="restore" size="20px"/></div>
					<div className="icon action-button save hidden" ref={ (f) => this.fields[ 'showbirthday_save' ] = f } onClick={ () => this.saveField( 'showbirthday', true ) } ><SvgIcon icon="check" size="20px"/></div>
				</dd>,
				<dd key="privacy_f" className="styled-field">
						<span
							className="selectedItem"
							onClick={ () => this.editField( 'showbirthday' ) }
							ref={ (f) => this.fields[ 'showbirthday' ] = f }
						>{ birthDaySettings.showbirthday_options[ showBirthDay ] }</span>
					<select
						className="hidden"
						name="showbirthday"
						ref={ (f) => this.fields[ 'showbirthday_select' ] = f }
						defaultValue={ showBirthDay }
						data-original={ showBirthDay }
					>{ showbirthdayOptions }</select>
				</dd>
			]
			: null;

		let settings = <dl>
				<dt>Birthday</dt>
					<dd className="options">
						<div className="icon action-button edit" ref={ (f) => this.fields[ 'birthday_edit' ] = f } onClick={ () => this.focusField( 'birthday' ) } ><SvgIcon icon="edit" size="20px"/></div>
						<div className="icon action-button restore hidden" ref={ (f) => this.fields[ 'birthday_restore' ] = f } onClick={ () => this.cancelField( 'birthday' ) } ><SvgIcon icon="restore" size="20px"/></div>
						<div className="icon action-button save hidden" ref={ (f) => this.fields[ 'birthday_save' ] = f } onClick={ () => this.saveField( 'birthday', true ) } ><SvgIcon icon="check" size="20px"/></div>
					</dd>
					<dd>
						<input
							type="date"
							autoComplete="bday"
							onFocus={ () => this.editField( 'birthday' ) }
							onInput={ () => this.editField( 'birthday' ) }
							ref={ (f) => this.fields[ 'birthday' ] = f }
							data-original={ birthdayFormated }
							defaultValue={ birthdayFormated }
						/>
					</dd>
				{ bdPrivacy }
			</dl>;

		return (
			<li className="settings-element">
				<div className="title">User Profile:</div>
				{ settings }
			</li>
		);
	}

	/** Avatar Methods **/
	addAvatar = () => {
		document.querySelector('#avatarPicker').click();
	};

	loadAvatar = ( evt ) => {
		const reader = new FileReader();
		let setState = this.setState.bind( this );
		let avatar = Object.assign( {}, this.state.avatar );

		reader.onload = () => {
			avatar.url = reader.result;
			avatar.scale = 1;
			setState( { avatar: avatar } );
			document.querySelector('#avatarPicker').value = null;
		};
		reader.readAsDataURL( evt.target.files[ 0 ] );
	};

	errorLoadingAvatar() {
		displayNotification( 'error', 'There was an error loading the image. Please try again or use a different image.' );
		this.resetAvatar();
	}

	saveAvatar = () => {
		let canvas = this.avatar.editor.getImageScaledToCanvas(),
			avatarLimits = this.props.ustate.usercp.profile.avatarLimits;

		canvas.toBlob( ( blob ) => {
			let formData = new FormData();
			formData.append( 'upload', blob, `avatar_${ new Date().getTime() }.png` );
			formData.append( 'newAvatar', true ); // we need to include an extra field to avoid vb 4.x error

			let message = <div>Are you sure you want to save this image as your avatar?
				<p><img src={ canvas.toDataURL("image/png", 1.0) } width={ avatarLimits.width ? avatarLimits.width : 100 } height={ avatarLimits.height ? avatarLimits.height : 100 }/></p>
			</div>;

			this.props.dispatch( showConfirmModal( 'Save avatar', message, () => { this.sendAvatar( formData ); } ) );
		}, 'image/png' );
	};

	deleteAvatar = () => {
		this.props.dispatch( showConfirmModal( 'Delete avatar', 'Are you sure you want to delete your avatar? (this action cannot be undone)' , () => {
				let formData = new FormData();
				formData.append( 'delete', true );
				this.sendAvatar( formData );
			} )
		);
	};

	sendAvatar( formData ) {
		let response = this.props.dispatch( uploadAvatar( formData ) );
		this.resetAvatar();

		response.then( result => {
			this.resetAvatar();
		} ).catch( ( error ) => {
			topifyConsole.error( error );
		} );
	}

	editAvatar = () => {
		let avatar = Object.assign( {}, this.state.avatar, { editAvatar: true } );
		this.setState( { avatar: avatar } );
		document.body.classList.add( 'no-scroll' );
		this.props.dispatch( trackGAEvent( false, 'editAvatar', 'userAction', 'userCP' ) );
	};

	resetAvatar = () => {
		let avatar = Object.assign(
			{},
			this.state.avatar,
			{
				editAvatar: false,
				url: null,
				scale: 1,
				rotate: 0,
				preview: null
			}
		);
		this.setState( { avatar: avatar } );
		document.body.classList.remove( 'no-scroll' );
	};

	handleScale() {
		let scale = parseFloat( this.avatar.scale.value ),
			avatar = Object.assign( {}, this.state.avatar, { scale: scale } );
		this.setState( { avatar: avatar } );
	}
	handleRotate() {
		let rotate = parseFloat( this.avatar.rotate.value ),
			avatar = Object.assign( {}, this.state.avatar, { rotate: rotate } );
		this.setState( { avatar: avatar } );
	}

	showAvatar() {
		let canChangeAvatar = this.props.ustate.usercp && this.props.ustate.usercp.profile && this.props.ustate.usercp.profile.avatarLimits.permissions,
			avatarLimits = canChangeAvatar ? this.props.ustate.usercp.profile.avatarLimits : null,
			border = 10,
			avatarUrl = this.state.avatar.url || this.props.ustate.avatar,
			scaleValue = this.state.avatar.scale || 1,
			rotateValue = this.state.avatar.rotate || 0,
			scaleStyle = null,
			canvasStyle = null;

		if( avatarLimits ) {
			let portrait = this.state.maxH > this.state.maxW,
				hNeed = document.getElementById( 'header' ).getBoundingClientRect().height + 24,
				width = portrait ? parseInt( this.state.maxH - hNeed ) : parseInt( this.state.maxW - hNeed ),
				maxW = portrait ? Math.min( 300, this.state.maxW ) : Math.min( 300, ( this.state.maxH - 125 ) );

			width = width > maxW ? maxW : width;

			scaleStyle = {
				width: width + 'px'
			};
			canvasStyle = { width: width + 'px', height: width + 'px' }
		}

		return ( avatarLimits && this.state.avatar.editAvatar ?
			<li className="settings-element avatarEditor" >
				<header className="block-buttons">
					<div className="action-button" onClick={ this.addAvatar }><SvgIcon size="24px" icon="upload_file"/></div>
					<div className="action-button" onClick={ this.deleteAvatar }><SvgIcon size="24px" icon="delete_forever"/></div>
					<div className="action-button" onClick={ this.saveAvatar }><SvgIcon size="24px" icon="check"/></div>
					<div className="action-button" onClick={ this.resetAvatar }><SvgIcon size="24px" icon="cancel"/></div>
				</header>

				<AvatarEditor
					ref={ (a) => this.avatar.editor = a }
					image={ avatarUrl }
					width={ avatarLimits.width }
					height={ avatarLimits.height }
					border={ border }
					color={[0,0,0, 0.5]} // RGBA
					scale={ this.state.avatar.scale }
					rotate={ this.state.avatar.rotate }
					onSave={ this.saveAvatar }
					style={ canvasStyle }
					onLoadFailure={ this.errorLoadingAvatar }
				/>

				<div className="avatar-controls">
					<div className="control">
						<p>Scale ( { scaleValue } )</p>
						<input ref={ (i) => this.avatar.scale = i } type="range" onChange={ () => { this.handleScale() } }
							   min="0.01" max="2" step="0.01" value={ scaleValue }
						   style={ scaleStyle } />
					</div>

					<div className="control">
						<p>Rotate ( { rotateValue } deg. )</p>
						<input ref={ ( i ) => this.avatar.rotate = i } type="range" onChange={ () => { this.handleRotate() } }
							   min="0" max="360" step="10" value={ rotateValue }
							   style={ scaleStyle }/>
					</div>

					<input type="file"
						   name="file"
						   id="avatarPicker"
						   accept="image/png, image/jpeg, image/jpg, image/gif" style={ {display: 'none'} }
						   onChange={ this.loadAvatar }
						   multiple={ false }
					/>
				</div>
			</li>
			:
			null
		);
	}

	/* ************** */

	render() {
		return (
			<div className="userCP settings thread">
				<ul>
					<li className="settings-element">
						<h3>Your User CP, { this.props.ustate.userName }</h3>
					</li>
					<li className="settings-element">
						<div className="title">Avatar:</div>
						<UserIcon user={ this.props.ustate } layout="editme" size="24px" noAction={ true } onClick={ this.editAvatar } />
					</li>
					{ this.showAvatar() }
					{ this.showEmailPass() }
					{ this.showUserProfile() }
					{ this.showUserOptions() }
				</ul>
			</div>
		);
	}
}

export default connect( userprofileResultSelector )( UserCPComponent );



// WEBPACK FOOTER //
// ./src/components/userCPComponent.js